import { UserTargetData, UserIdentify } from '@types'
import * as Sentry from '@sentry/browser'

export class EventsService {
  constructor(private readonly sentryInstance: typeof Sentry) {}

  private _target: UserTargetData = {
    isAdmin: false,
    email: '',
    type: undefined,
  }

  get target(): UserTargetData {
    return this._target
  }

  set target(newValue: UserTargetData) {
    this._target = newValue
  }

  private getIdentity(isAnonymous?: boolean, data?: UserIdentify) {
    const payload = data || {
      id: this.target.authId,
      email: `${this.target.email}`,
    }
    return {
      ...payload,
      email: isAnonymous ? 'anonymous' : `${payload.email}`,
    }
  }

  identityGlobalContext(isAnonymous?: boolean, data?: UserIdentify) {
    this.sentryInstance.setUser(this.getIdentity(isAnonymous, data))
  }

  identityContext(data: { [key: string]: string }) {
    this.sentryInstance.setContext('Additional Parameters', data)
  }


  error(error: Error) {
    this.sentryInstance.captureException(error)
  }
}
